import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'

const axios = getAxios()

export const processSfLWCRedirect = async (requestData, dispatch) => {
  if (!requestData || !requestData.recordID || !requestData.url) {
    return false
  }

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/sfLWCRedirect')
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)
  if (data.status) {
    let separator = ''
    if (String(requestData).indexOf('?') > -1) {
      separator = '&'
    } else {
      separator = '?'
    }
    location.href = `${requestData.url}${separator}ftSFToken=${data.token}&ftlwcid=${requestData.recordID}`
  }
}
